import { combineReducers } from "redux";
import countryReducer from "./country/countryReducer";
import GlobalAttributesReducer from "./GlobalAttributes/GlobalReducer";
import RegionAttributesReducer from "./RegionAttributes/RegionReducer";
import AllRegionAttributesReducer from "./AllRegionAttributes/AllRegionReducer";
import RetailerAttributesReducer from "./RetailerAttributes/RetailerReducer";
import AllRetailerAttributesReducer from "./AllRetailerAttributes/AllRetailerReducer";
import LOVReducer from "./LOVAttributes/LOVReducer";
import countDataReducer from './Dashboard/countDataReducer';
import TaxonomyReducer from "./Taxonomy/TaxonomyReducer";
 
const rootReducer = combineReducers({
  country: countryReducer,
  GlobalAttributesData: GlobalAttributesReducer, 
  RegionAttributesData: RegionAttributesReducer, 
  AllRegionAttributesData:AllRegionAttributesReducer,
  RetailerAttributesData: RetailerAttributesReducer, 
  AllRetailerAttributesData: AllRetailerAttributesReducer,
  lov: LOVReducer,
  countData: countDataReducer, 
  TaxonomyData:TaxonomyReducer
});

export default rootReducer;
